import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

//******************************************************************************
//  NPM (Packages) External
//******************************************************************************
import { SDKLoadingModule } from 'sdk-loading';

//******************************************************************************
//  Services
//******************************************************************************
import { AppSettingsService } from '~/core/services/appsettings.service';
import { GraphService } from '~/core/services/graph.service';
import { FormatterService } from '~/core/services/formatter.service';

//******************************************************************************
//  Pages
//******************************************************************************
import { AuthComponent } from '~/core/pages/auth/auth.component';
import { NotFoundComponent } from '~/core/pages/notfound/notfound.component';

//******************************************************************************
//  Core Components
//******************************************************************************
import { HeaderComponent } from '~/core/components/layout/header/header.component';
import { FooterComponent } from '~/core/components/layout/footer/footer.component';
import { AccessComponent } from '~/core/components/access/access.component';
import { AlertComponent } from '~/core/components/alert/alert.component';
import { ErrorComponent } from '~/core/components/error/error.component';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

//******************************************************************************
//  Pipes
//******************************************************************************

const components: any[] = [
    HeaderComponent,
    FooterComponent,
    AccessComponent,
    AlertComponent,
    ErrorComponent,

    AuthComponent,
    NotFoundComponent,
];

const pipes: any[] = [
];

const services: any[] = [
    AppSettingsService,
    GraphService,
    FormatterService,
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SDKLoadingModule,
    ],
    declarations: [
        ...components,
        ...pipes,
    ],
    exports: [
        CommonModule,
        FormsModule,
        MatDialogModule,
        ...components,
        ...pipes,
    ],
    providers: [
        ...services,
        { provide: MAT_DIALOG_DATA, useValue: {} },
        { provide: MatDialogRef, useValue: {} }
    ],
})

export class CoreImports { }
